module.exports = __webpack_public_path__ + "assets/0c5b8d44c13f491d37d22ea7a88ba3dd.png";